import React from 'react';
import useAppContext from '../../../context/useAppContext';
import PropTypes from 'prop-types';

import { useParams } from 'react-router-dom';

import { Button, LinkWithActions } from '@weezevent/nacre';
import TicketCard from '../../attendee/detail/components/ticket-card/ticketCard';
import { useTranslation } from 'react-i18next';
import { Placeholder } from 'semantic-ui-react';

import Style from './detail.module.css';
import PaymentLink from '../../../models/paymentLink';
import { SendPaymentRequest, SendUpdateInfoRequest } from '../actions/sendRequest';

export default function PaymentUrl({ order, setAction }) {
    const { t } = useTranslation();
    const { order_id } = useParams();
    const [{ event, organization, feature_flags }] = useAppContext();

    const [paymentUrl, paymentUrlLoading] = PaymentLink.useApiModel({
        orderId: order_id,
        eventId: event.pk,
        organizationId: organization.pk
    });

    const action = React.useMemo(() => {
        if (order && order.origin !== 'weez_distributor') {
            if (SendPaymentRequest.is_available({ event, feature_flags, items: [order] }) && SendPaymentRequest.condition(order)) {
                return SendPaymentRequest;
            }
            if (SendUpdateInfoRequest.is_available({ event, feature_flags, items: [order] }) && SendUpdateInfoRequest.condition(order)) {
                return SendUpdateInfoRequest;
            }
            return null;
        }
    }, [order, event, feature_flags, SendUpdateInfoRequest]);

    if (!action) {
        return null;
    }

    return (
        <TicketCard.Footer>
            <div className={Style['payment-link-title']}>{t('ticket.common.orderFinalization')}</div>
            <div className={Style['payment-link']}>
                {paymentUrlLoading ? (
                    <Placeholder>
                        <Placeholder.Paragraph>
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                        </Placeholder.Paragraph>
                    </Placeholder>
                ) : (
                    <>
                        <LinkWithActions tooltipText={paymentUrl[0]} url={paymentUrl[0]} />
                        <Button primary onClick={() => setAction({ action: action, items: [order] })}>
                            {t('ticket.manager.orders.action.send_payment_request.dropdownItem')}
                        </Button>
                    </>
                )}
            </div>
        </TicketCard.Footer>
    );
}

PaymentUrl.propTypes = {
    order: PropTypes.object.isRequired,
    setAction: PropTypes.func.isRequired
};
